var utils = require('../utils');

var delCookie = function (name) {
    document.cookie = name + '=;expires=' + new Date(0).toGMTString() + ';domain=.ifeng.com;path=/';
};

var sidChecked = false;

var checkSid = function (callback) {
    var sid = utils.getCookie('sid');
    if (sid) {
        if (!sidChecked) {
            $.ajax({
                url: '//id.ifeng.com/api/checklogin',
                type: 'get',
                dataType: 'jsonp',
                data: {
                    sid: sid
                },
                success: function (msg) {
                    sidChecked = true;
                    if (msg.code == 1) {
                        callback(sid);
                    } else {
                        delCookie('sid');
                        callback(false);
                    }
                }
            });
        } else {
            callback(sid);
        }
    } else {
        sidChecked = true;
        callback(false);
    }
};

module.exports = checkSid;


// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.compenont.barrage.pc/app/modules/checkSid/index.js